import { FC } from 'react';

type Props = {
	className?: string;
};

const DiscountIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#EAEAEA'
			className={className}>
			<path
				d='M6.55328 16.0926C7.02609 16.0926 7.26249 16.0926 7.47786 16.1725C7.50778 16.1836 7.53726 16.1958 7.56626 16.2091C7.77506 16.3049 7.94222 16.472 8.27655 16.8063C9.0461 17.5758 9.43081 17.9606 9.90424 17.9961C9.96784 18.0009 10.0318 18.0009 10.0954 17.9961C10.5689 17.9606 10.9537 17.5758 11.7231 16.8063C12.0575 16.472 12.2246 16.3049 12.4334 16.2091C12.4624 16.1958 12.4919 16.1836 12.5218 16.1725C12.7372 16.0926 12.9736 16.0926 13.4464 16.0926H13.5336C14.7399 16.0926 15.3431 16.0926 15.7178 15.7178C16.0926 15.3431 16.0926 14.7399 16.0926 13.5336V13.4464C16.0926 12.9736 16.0926 12.7372 16.1725 12.5218C16.1836 12.4919 16.1958 12.4624 16.2091 12.4334C16.3049 12.2246 16.472 12.0575 16.8063 11.7231C17.5758 10.9537 17.9606 10.5689 17.9961 10.0954C18.0009 10.0318 18.0009 9.96784 17.9961 9.90424C17.9606 9.43081 17.5758 9.0461 16.8063 8.27655C16.472 7.94222 16.3049 7.77506 16.2091 7.56626C16.1958 7.53726 16.1836 7.50778 16.1725 7.47786C16.0926 7.26249 16.0926 7.02609 16.0926 6.55328V6.46606C16.0926 5.25977 16.0926 4.65661 15.7178 4.28187C15.3431 3.90711 14.7399 3.90711 13.5336 3.90711H13.4464C12.9736 3.90711 12.7372 3.90711 12.5218 3.8272C12.4919 3.81611 12.4624 3.80389 12.4334 3.79059C12.2246 3.69481 12.0575 3.52764 11.7231 3.19331C10.9537 2.42381 10.5689 2.03906 10.0954 2.00358C10.0318 1.99881 9.96784 1.99881 9.90424 2.00358C9.43081 2.03906 9.0461 2.42381 8.27655 3.19331C7.94222 3.52764 7.77506 3.69481 7.56626 3.79059C7.53726 3.80389 7.50778 3.81611 7.47786 3.8272C7.26249 3.90711 7.02609 3.90711 6.55328 3.90711H6.46606C5.25977 3.90711 4.65661 3.90711 4.28187 4.28187C3.90711 4.65661 3.90711 5.25977 3.90711 6.46606V6.55328C3.90711 7.02609 3.90711 7.26249 3.8272 7.47786C3.81611 7.50778 3.80389 7.53726 3.79059 7.56626C3.69481 7.77506 3.52764 7.94222 3.19331 8.27655C2.42381 9.0461 2.03906 9.43081 2.00358 9.90424C1.99881 9.96784 1.99881 10.0318 2.00358 10.0954C2.03906 10.5689 2.42381 10.9537 3.19331 11.7231C3.52764 12.0575 3.69481 12.2246 3.79059 12.4334C3.80389 12.4624 3.81611 12.4919 3.8272 12.5218C3.90711 12.7372 3.90711 12.9736 3.90711 13.4464V13.5336C3.90711 14.7399 3.90711 15.3431 4.28187 15.7178C4.65661 16.0926 5.25977 16.0926 6.46606 16.0926H6.55328Z'
				stroke='inherit'
				strokeWidth='1.19998'
			/>
			<path
				d='M12.4015 7.6001L7.60156 12.4'
				stroke='inherit'
				strokeWidth='1.19998'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M12.4015 12.4H12.3928M7.61017 7.6001H7.60156'
				stroke='inherit'
				strokeWidth='1.75'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default DiscountIcon;
